import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { SupplementaryEquipmentResponse, TruckDetails } from './truck.model';

@Injectable({
  providedIn: 'root'
})
export class TruckService {

  constructor(private httpService: HttpService) { }

  public saveTruck(truck: TruckDetails): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.truckEndpoint + '/save', truck);
  }

  public getTruckDetails(truckId: number): Observable<TruckDetails> {
    return this.httpService.postWithContext(environment.truckEndpoint + '/details', truckId);
  }

  public checkLeaveAllowed(truckId: number): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.truckEndpoint + '/check-leave', truckId);
  }

  public registerLeave(truckId: number): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.truckEndpoint + '/register-leave', truckId);
  }

  public getAvailableSupplementaryEquipments(): Observable<SupplementaryEquipmentResponse> {
    return this.httpService.postWithContext<SupplementaryEquipmentResponse>(environment.truckEndpoint + '/supplementaryequipment',
      {});
  }

  public findTrucksByNumberplate(numberplate: string): Observable<TruckDetails[]> {
    return this.httpService.postWithContext(environment.truckEndpoint + '/find', numberplate);
  }
}
